import { service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { advancedFiltersMovedTour } from 'tio-common/utils/tours/advanced-filters-moved-tour';
import ProgramsPage from 'tio-common/components/reporting/tas/programs-page';
import TioPageBreadcrumbs from 'tio-common/components/tio/page/breadcrumbs';
import TourTrigger from 'tio-common/components/tours/tour-trigger';
import type SessionContext from 'tio-employee/services/session-context';
import type Company from 'tio-common/models/company';
import type TasProgramsController from 'tio-employee/controllers/authenticated/admin/reporting/tas-programs';
import type TourManagerService from 'tio-common/services/tour-manager';

export interface ReportingTasProgramsRouteSignature {
  Args: {
    model: Company;
    controller: TasProgramsController;
  };
}

export default class ReportingTasProgramsRouteComponent extends Component<ReportingTasProgramsRouteSignature> {
  @service declare sessionContext: SessionContext;
  @service declare tourManager: TourManagerService;

  constructor(owner: unknown, args: ReportingTasProgramsRouteSignature['Args']) {
    // @ts-expect-error - Owner type mismatch is ok here
    super(owner, args);
    this.registerTours();
  }

  private registerTours() {
    // Register the advanced filters tour
    // In the future, these tour configs would come from a database via API
    this.tourManager.registerTour(advancedFiltersMovedTour);
  }

  get companyId() {
    return this.args.model?.id;
  }

  <template>
    {{! Tour trigger for advanced filters location }}
    <TourTrigger @tourId="advanced-filters-moved" @autoStart={{true}} @delay={{500}} />

    <ProgramsPage
      @company={{@model}}
      @controller={{@controller}}
      @baseRoute="authenticated.admin.tuition-assistance"
      @applicationDetailRoute="authenticated.admin.tuition-assistance.applications.show"
      @programDetailRoute="authenticated.admin.tuition-assistance.program-instances.show"
      @showViewToggle={{false}}
      @showSaveReports={{false}}
      @showColumnSelector={{false}}
    >
      <:breadcrumbs>
        <TioPageBreadcrumbs as |b|>
          <b.crumb
            @route="authenticated.admin.reporting.index"
            @label={{t "common.reporting.default"}}
          />
        </TioPageBreadcrumbs>
      </:breadcrumbs>
    </ProgramsPage>
  </template>
}
